export default [
  {
    path: '/',
    name: 'articleLayout',
    redirect: { name: 'article' },
    component: () => import('@/views/layout'),
    children: [
      {
        path: '/publish',
        name: 'publish',
        components: {
          default: () => import('@/views/article/publish'),
        },
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/detail',
        name: 'detail',
        components: {
          default: () => import('@/views/article/detail'),
        }
      },
      // {
      //   path: '/detail/:id',
      //   name: 'detail',
      //   components: {
      //     default: () => import('@/views/article/detail'),
      //   }
      // },
      {
        path: '/article/chooseTags',
        name: 'chooseTags',
        components: {
          default: () => import('@/views/article/chooseTags'),
        }
      },
      {
        path: '/article/chooseCategory',
        name: 'chooseCategory',
        components: {
          default: () => import('@/views/article/chooseCategory'),
        }
      },
      {
        path: '/article/commentList',
        name: 'articleCommentList',
        components: {
          default: () => import('@/views/article/commentListPage'),
        }
      }
    ]
  }
]